export default __webpack_public_path__ + "static/media/c29b03507001e3f6fb0fd283e1f50328e5993d2ade690f1b66ddf5dbd80de55f.166fd931.svg";